import { render, staticRenderFns } from "./tableRate.vue?vue&type=template&id=64aa0fd4&scoped=true&"
import script from "./tableRate.vue?vue&type=script&lang=js&"
export * from "./tableRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa0fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64aa0fd4')) {
      api.createRecord('64aa0fd4', component.options)
    } else {
      api.reload('64aa0fd4', component.options)
    }
    module.hot.accept("./tableRate.vue?vue&type=template&id=64aa0fd4&scoped=true&", function () {
      api.rerender('64aa0fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableRate.vue"
export default component.exports